import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalValue'
})
export class MgDecimalValuePipe implements PipeTransform {
    finalString = '';
    count = 0;
    decimalValue;
    transform(value: string) {
        this.finalString = '';
        this.count = 0;
        if (value != null) {
            this.decimalValue = '-';
            if (value.toString().indexOf('.')>-1) {
                this.decimalValue = value.toString().split('.')[1];
                value = value.toString().split('.')[0];
            }
            const lengthValue = value.toString().length;
            if (lengthValue > 3) {
                const ValueArry = value.toString().split('');
                for (let i = ValueArry.length - 1; i >= 0; i--) {
                    this.count = this.count + 1;
                    this.finalString = this.finalString + ValueArry[i];
                    if (this.count === 3) {
                        if(i!=0)
                        {
                        this.finalString = this.finalString + '.';
                        } else {
                            this.finalString = this.finalString ;
                        }

                        this.count = 0;
                    }
                }
                // tslint:disable-next-line:max-line-length
                // this.finalString= value.toString().substr(0,value.toString().length-3) +'.'+value.toString().substr(value.toString().length-3,3)
                const ReverserString = this.finalString.split('');
                ReverserString.reverse();
                if (this.decimalValue.length === 1 && this.decimalValue!='-') {
                    this.decimalValue = this.decimalValue + '0';
                }
                // if(this.decimalValue!=undefined && this.decimalValue!=0)
                // {
                return 'Kr. ' + ReverserString.toString().replace(/,/g, '') //+ ',' + this.decimalValue.substr(0,2);
                // }
                // return 'Kr. ' + ReverserString.toString().replace(/,/g, '') + ' ,-';
                // this.finalString= this.finalString.toString();
                // return this.finalString.replace(',','');
            } else {
                if (this.decimalValue.length === 1 && this.decimalValue!='-') {
                    this.decimalValue = this.decimalValue + '0';
                }
                return 'Kr. ' + `${value}` //+ ',' + this.decimalValue;
            }
        } else {
            return ',-';
        }
        // if (completeWords) {
        // minlimit = value.substr(0, 13).lastIndexOf(' ');
        // }
        // if (value != null) {
        // if (value.length < 25) {
        // return `${value.substr(0, minlimit)}`;
        // } else {
        // return `${value.substr(0, minlimit)}${ellipsis}`;
        // }
        // }
    }
}
